/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { DeleteAssetTypeMutation, DeleteAssetTypeMutationVariables } from "@models/graphql";

const defaultDeleteAssetTypeOptions: MutationHookOptions<DeleteAssetTypeMutation, DeleteAssetTypeMutationVariables> = {};

export const useDeleteAssetType = (options?: MutationHookOptions<DeleteAssetTypeMutation, DeleteAssetTypeMutationVariables>) => {
    const [mutation, { data, loading, error }] = useMutation<DeleteAssetTypeMutation, DeleteAssetTypeMutationVariables>(
        GraphQLDocuments.deleteAssetType
    );

    const deleteAssetType = async (
        variables: DeleteAssetTypeMutationVariables,
        opts?: MutationHookOptions<DeleteAssetTypeMutation, DeleteAssetTypeMutationVariables>
    ) => {
        try {
            const response = await mutation({
                ...defaultDeleteAssetTypeOptions,
                ...options,
                ...opts,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        deleteAssetType
    };
};
